(() => {
  const cartSectionsToRender = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
  ];

  const getSectionInnerHTML = (html, selector) => {
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  };

  const pushAddToCart = (form) => {
    const analytics = window.PilatesAnalytics;
    if (!analytics || typeof analytics.pushAddToCart !== 'function') return;

    const params = {
      itemId: form.dataset.itemId,
      itemName: form.dataset.itemName,
      price: Number(form.dataset.itemPrice) || 0,
    };

    analytics.pushAddToCart(params);
  };

  const updateImage = (image, src) => {
    if (!image || !src) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
  };

  const setActiveSwatch = (root, activeSwatch) => {
    const swatches = Array.from(root.querySelectorAll('[data-pilates-included-swatch]'));
    const mainImage = root.querySelector('[data-pilates-included-main-image]');
    const accessoryImages = Array.from(root.querySelectorAll('[data-pilates-included-accessory-image]'));

    swatches.forEach((swatch) => {
      const isActive = swatch === activeSwatch;
      swatch.classList.toggle('is-selected', isActive);
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateImage(mainImage, activeSwatch.getAttribute('data-main-image'));

    accessoryImages.forEach((image) => {
      const index = image.getAttribute('data-accessory-index');
      updateImage(image, activeSwatch.getAttribute(`data-accessory-image-${index}`));
    });

    const form = root.querySelector('[data-pilates-included-cart-form]');
    const hiddenInput = form?.querySelector('input[name="id"]');
    const submitBtn = form?.querySelector('button[type="submit"]');
    const variantId = activeSwatch.dataset.variantId;
    const isSoldOut = activeSwatch.dataset.soldOut === 'true';

    if (hiddenInput && variantId) {
      hiddenInput.value = variantId;
      form.dataset.itemId = variantId;
    }

    if (submitBtn) {
      const addText = submitBtn.dataset.addText || '';
      const soldOutText = submitBtn.dataset.soldOutText || 'Sold Out';
      const textSpan = submitBtn.querySelector('span:last-child');

      if (isSoldOut) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        if (textSpan) textSpan.textContent = soldOutText;
      } else {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
        if (textSpan) textSpan.textContent = addText;
      }
    }
  };

  const handleCartSubmit = (form, button) => {
    if (button.classList.contains('is-loading') || button.disabled) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');

    const sectionsParam = cartSectionsToRender.map((section) => section.section).join(',');
    const cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    const formData = new FormData(form);
    formData.append('sections', sectionsParam);
    formData.append('sections_url', window.location.pathname);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(async (response) => {
        let data;
        try {
          data = await response.json();
        } catch (_) {
          throw new Error('cart_add_response_not_json');
        }

        if (!response.ok || data.status) {
          const message = data && (data.description || data.message);
          throw new Error(message || 'cart_add_failed');
        }

        return data;
      })
      .then((data) => {
        if (data.sections) {
          cartSectionsToRender.forEach(({ id, section, selector }) => {
            const host = document.getElementById(id);
            if (!host || !data.sections[section]) return;
            const target = host.querySelector(selector) || host;
            target.innerHTML = getSectionInnerHTML(data.sections[section], selector);
          });

          if (typeof Cart !== 'undefined') {
            try {
              new Cart().renderContents({ sections: data.sections });
            } catch (_) {}
          }
        }

        const drawer = document.getElementById('Cart-Drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:item-added', {
            bubbles: true,
            detail: { product: data.items ? data.items[0] : data },
          })
        );

        pushAddToCart(form);
      })
      .catch((error) => {
        console.error('[pilates-set-included] add-to-cart failed:', error);
      })
      .finally(() => {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  };

  const initIncludedSet = (root) => {
    if (root.dataset.pilatesIncludedReady === 'true') return;

    root.dataset.pilatesIncludedReady = 'true';

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-pilates-included-swatch]');
      if (!swatch || !root.contains(swatch)) return;

      setActiveSwatch(root, swatch);
    });

    const cartForm = root.querySelector('[data-pilates-included-cart-form]');
    if (cartForm) {
      cartForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = cartForm.querySelector('button[type="submit"]');
        if (!button) return;
        handleCartSubmit(cartForm, button);
      });
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-pilates-included]').forEach(initIncludedSet);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
